"use strict";


/**
 *	Utils
 */


/**
 *	Array random value
 *
 *	@params {Array} array
 *	@params {Boolean} exclude
 *	@params {Number} value
 */

	export function arrayRandomValue( array, exclude, value ) {
		if ( !exclude ) {
			return array[ Math.floor( Math.random() * array.length ) ];
		}
	
		array = u.grep( array, function( element ) {
			return element !== value;
		});
	
		return array[ Math.floor( Math.random() * array.length ) ];
	}


/**
 *	Random between
 *
 *	@params {Number} min
 *	@params {Number} max
 *	@params {Number} decimals
 */

	export function randomBetween( min, max, decimals ) {
		var value = Math.random() * ( max - min ) + min;
		return value.toFixed( decimals );
	}


/**
 *	In array
 *
 *	@params {Mixed} value
 *	@params {Array} array
 */

	export function inArray( value, array ) {
		return ( array.indexOf(value) != -1 ) ? true : false;
	}


/**
 *	Get closest number
 *
 *	@params {Number} goal
 *	@params {Array} array
 *
 *	NOTA:
 *	*****
 *	La soluzione adottata per trovare il numero più vicino alla dimensione del
 *	contenitore è un piccolo snippet trovato su stackoverflow che utilizza la
 *	funzione nativa per elaborare gli array: array.reduce
 *
 *	Link soluzione:
 *	***************
 *	https: //stackoverflow.com/questions/8584902/get-closest-number-out-of-array
 */

	export function getClosestNumber( goal, array ) {
		var result = array.reduce(function( prev, curr ) {
			return ( Math.abs(curr - goal) < Math.abs(prev - goal) ) ? curr : prev;
		});

		return result;
	}


/**
 *	Merge objects
 *
 *	@params {Object} to
 *	@params {Object} from
 */

	export function mergeObjects( to, from ) {
		if ( typeof to === 'object' && typeof from === 'object' ) {
			for ( var pro in from ) {
				if ( from.hasOwnProperty(pro) ) {
					to[pro] = from[pro];
				}
			}
		} else {
			throw "Merge function can apply only on object";
		}
	}

	/*
		function merge(objectArray) {
		    if (objectArray.length) {
		        var b = "", i = -1;
		        while (objectArray[++i]) {
		            var str = JSON.stringify(objectArray[i]);
		            b += str.slice(1, str.length - 1);
		            if (objectArray[i + 1]) b += ",";
		        }
		        return JSON.parse("{" + b + "}");
		    }
		    return {};
		}
	*/


/**
 *	Is mobile
 */

	export function isMobile() {
		if ( /Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent) ) {
			return true;
		}

		return false;
	}
	

/**
 *	Transition end
 */

	export function transitionEnd() {
	    var t,
			el = document.createElement( "fakeelement" ),
			transitions = {
		      "transition": "transitionend",
		      "OTransition": "oTransitionEnd",
		      "MozTransition": "transitionend",
		      "WebkitTransition": "webkitTransitionEnd"
		    };
	    for ( t in transitions ) {
	        if ( el.style[t] !== undefined ) {
	            return transitions[t];
	        }
	    }
	}
	

/**
 *	Animation end
 */

	export function animationEnd() {
	    var t,
			el = document.createElement("fakeelement"),
			animations = {
		      "animation":"animationend",
		      "OAnimation":"oAnimationEnd",
		      "MozAnimation":"animationend",
		      "WebkitAnimation":"webkitAnimationEnd"
		    };
	    for (t in animations) {
	        if (el.style[t] !== undefined) {
	            return animations[t];
	        }
	    }
	}


/**
 *	Filled scroll gap
 */

	export function filledScrollGap( start, position, gap ) {
		var currentGap = Math.abs( start - position );
		//console.log( currentGap );
		return ( currentGap < gap ) ? false : true;
	}


/**
 *	Get computed styles support
 *
 *	Github:
 *	https: //gist.github.com/markhowellsmead/5f8360c99b22b86f1dc6eae164583014
 */

	export function getComputedStylesSupport() {
		if ( typeof window.getComputedStyle(document.body).mixBlendMode === "undefined" ) {
			return false;
		}

		return true;
	}